export const QUERY_PARAMETER_PORTCALL = 'portcallId'
export const QUERY_PARAMETER_VESSEL = 'vesselId'
export const QUERY_PARAMETER_SCHEDULE = 'portcallIdForSchedule'
